// extracted by mini-css-extract-plugin
export var chevronIcon = "_bh-2";
export var teamName = "_bh-1";
export var teamSwitcherButton = "_bh-0";